<template>
    <div v-bind:class="className">
        <div class="layout-ccr-paragraph" v-bind:class="{'layout-ccr-paragraph-all':showAll && textValueLong}">
            <p v-if="textId == 'suggestread'" v-bind:id="'readcontent' + textId" v-html="UTILS.getCommentWechatUrl(UTILS.getBreakLineByText(textValue))"></p>
            <p v-else v-bind:id="'readcontent' + textId" v-html="UTILS.getBreakLineByText(textValue)"></p>
        </div>
        <div class="layout-cep-edit-half edit-left"><span class="span-show-all" v-if="textValueLong" @click="clickShowAll">{{showAllText}}</span></div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
export default {
    name: 'CommentContentRead',
    props: {
        className: {
            type: String,
            default() { return '' }
        },
        textId: {
            type: String,
            default() { return '' }
        },
        textValue: {
            type: String,
            default() { return '' }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            textValueLong: false,
            showAll: false,
            showAllText: '显示全文'
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.checkTextValue();
        }, 20);
    },
    methods: {
        clickShowAll() {
            var curShowAll = this.showAll; this.showAll = !curShowAll;
            this.showAllText = this.showAll ? '收起' : '显示全文';
            this.$bus.emit('updateCommentScrollFunc');
        },
        checkTextValue() {
            var pNode = document.getElementById('readcontent' + this.textId);
            if(pNode != null){
                if(pNode.clientHeight > pNode.parentNode.clientHeight) {
                    this.textValueLong = true;
                }else {
                    this.textValueLong = false;
                    pNode.parentNode.style.height = 'auto';
                }
            }
        }
    }
}
</script>